var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHomeicon = function SvgHomeicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.455 12.4H1.6V6.485L7 2.067l5.4 4.418V12.4H9.546v-2.218a2.546 2.546 0 0 0-5.091 0V12.4Zm1.6 0h1.89v-2.218a.946.946 0 0 0-1.89 0V12.4ZM0 5.964a.5.5 0 0 1 .183-.387L6.683.26a.5.5 0 0 1 .634 0l6.5 5.318a.5.5 0 0 1 .183.387v6.763C14 13.43 13.43 14 12.727 14H1.273C.57 14 0 13.43 0 12.727V5.964Z",
    clipRule: "evenodd"
  })));
};
export default SvgHomeicon;